import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { Control, Label, Select } from "rbx";
import { useQuery } from "@apollo/client";
import { GET_REVIEW_TEMPLATES } from "../../graphql";

const ReviewTemplateSelect = ({
  label,
  size,
  name,
  onChange,
  disabled,
  value,
  required,
  getValue,
  setValue,
  showBlank,
  showAll,
}) => {
  const { data: reviewTemplatesData, loading: reviewTemplateDataLoading } =
    useQuery(GET_REVIEW_TEMPLATES, {
      variables: {},
    });

  const indicateRequired =
    required && (!value || value === "" || value === "0" || value === 0);

  const reviewTemplates = reviewTemplatesData?.reviewTemplates;

  const handleChange = (e) => {
    onChange(e.target.name, setValue(e.target.value));
  };

  useEffect(() => {
    if (
      reviewTemplates &&
      reviewTemplates?.length > 0 &&
      !value &&
      !showBlank &&
      !showAll
    ) {
      onChange(name, `${reviewTemplates[0]?.firstName} ${reviewTemplates[0]?.lastName}`);
    }
  }, [
    reviewTemplates,
    reviewTemplates?.length,
    getValue,
    name,
    onChange,
    showAll,
    showBlank,
    value,
  ]);

  return (
    <Control size={size}>
      {label && <Label>{label}</Label>}
      <Select.Container
        fullwidth
        size={size}
        state={reviewTemplateDataLoading || Array.isArray(reviewTemplates) ? "" : "loading"}
      >
        <Select
          disabled={disabled}
          name={name}
          required={required}
          style={{
            border: indicateRequired ? "1px #e63362 solid" : "",
            borderRadius: "4px",
            boxShadow: indicateRequired
              ? "0 0 0 0.125em rgba(230, 51, 98, 0.25)"
              : "",
          }}
          value={getValue(value)}
          onChange={handleChange}
        >
          {showBlank && <Select.Option value="" />}
          {showAll && <Select.Option value="">All</Select.Option>}
          {Array.isArray(reviewTemplates) &&
            reviewTemplates.map(({ id, title }) => (
              <Select.Option
                key={id}
                value={id}
              >
                {title}
              </Select.Option>
            ))}
        </Select>
      </Select.Container>
    </Control>
  );
};

ReviewTemplateSelect.propTypes = {
  value: PropTypes.string,
  name: PropTypes.string,
  label: PropTypes.string,
  size: PropTypes.string,
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
  required: PropTypes.bool,
  getValue: PropTypes.func,
  setValue: PropTypes.func,
  showBlank: PropTypes.bool,
  showAll: PropTypes.bool,
};

ReviewTemplateSelect.defaultProps = {
  size: "normal",
  disabled: false,
  value: "",
  name: "",
  label: "",
  required: false,
  showBlank: false,
  showAll: false,
  getValue: (x) => x,
  setValue: (x) => x,
  onChange: () => {},
};

export default ReviewTemplateSelect;
